module.exports = __webpack_public_path__ + "fonts/OptimusPrincepsSemiBold.39fc3d3.ttf";